import objectByID from './objectByID';
import { HANDLE_NEW_QDD } from '../actions/sync';
import { createSelector } from 'reselect'
import { UPDATE_SORT_INDEXES } from '../actions/question';
import { updateSortIndex } from "../sortIndex";
import { CREATE_TRANSLATION, SAVE_CAT_TRANSLATION, SAVE_TR_METADATA, SAVE_Q_TRANSLATION } from "../actions/translation"

const translationList = (state = [], action) => {
  switch(action.type) {
    case CREATE_TRANSLATION:
      var newTrInfo = Object.assign({id:action.id, title: action.title, published: false, updatedAt: (new Date()).getTime()})
      return[...state, newTrInfo]
    case SAVE_CAT_TRANSLATION:
    case SAVE_Q_TRANSLATION:
      //update update time flag for comparision of changes without having to load in full translations
      var trInfo = objectByID(state, action.trID);
      var index = state.indexOf(trInfo);
      return [
            ...state.slice(0, index),
            Object.assign({}, trInfo, {updatedAt: (new Date()).getTime()}),
            ...state.slice(index+1)
       ];
    case SAVE_TR_METADATA:
      var trInfo = objectByID(state, action.trID);
      var index = state.indexOf(trInfo);
      return [
            ...state.slice(0, index),
            Object.assign({}, trInfo, {title: action.props.title, published: action.props.published, updatedAt: (new Date()).getTime()}),
            ...state.slice(index+1)
       ];
    case HANDLE_NEW_QDD:
      let trList = action.payload.translationList ? action.payload.translationList : []
      return trList;
    default:
      return state;
  }
}

export default translationList;
